// extracted by mini-css-extract-plugin
export default {"inputHolder":"NewAudience_inputHolder__+BUMN"};